import { useEffect, useState } from "react";
import { Box, IconButton, Menu, Typography } from "@mui/material";
import SettingsOutlinedIcon from "@mui/icons-material/SettingsOutlined";
import PersonOutlinedIcon from "@mui/icons-material/PersonOutlined";
import MenuItem from "@mui/material/MenuItem";
import API from "../../api/index";
import { useNavigate } from "react-router-dom";
import SelectLecs from "../../components/selectedLecs";
import NotifyMenu from "../../components/notify";
import Tour from "../../components/alltour";

const TotalNodes = ({ nNodes = 0 }) => {
  const [, setIsAnimating] = useState(false);

  useEffect(() => {
    let limitNodes;
    switch (sessionStorage.getItem("tipoLecs")) {
      case "LECS-CORE-4":
        limitNodes = 800;
        break;
      case "LECS-64":
        limitNodes = 150;
        break;
      case "LECS-CORE-2":
        limitNodes = 200;
        break;
      case "LECS":
        limitNodes = 30;
        break;
      case "LECS-CORE-SFP":
        limitNodes = 1500;
        break;
      default:
        limitNodes = 100;
        break;
    }

    if (nNodes > limitNodes) {
      setIsAnimating(true);
      sessionStorage.setItem("limitNodesExceeded", "true");
    } else {
      setIsAnimating(false);
      sessionStorage.setItem("limitNodesExceeded", "false");
    }
  }, [nNodes]);

  const exceededNodes = sessionStorage.getItem("limitNodesExceeded") === "true";
  const exceededBand = sessionStorage.getItem("limitBandExceeded") === "true";

  return (
    <Typography
      style={{
        color: exceededNodes && exceededBand ? "red" : exceededNodes ? "orange" : "white",
        fontSize: "1rem",
        transition: "color 0.3s ease, transform 0.3s ease",
        animation: exceededNodes && exceededBand ? "pulse 0.5s infinite alternate, flashColor 0.5s infinite alternate" : "none",
      }}
    >
      Active Hosts: {nNodes}{" "}
      {exceededNodes && exceededBand && "Please verify your license"}
      <style>
        {`
          @keyframes pulse { from { transform: scale(1); } to { transform: scale(1.2); } }
          @keyframes flashColor { from { color: red; } to { color: white; } }
        `}
      </style>
    </Typography>
  );
};

const Topbar = ({ aiView, setAiView }) => {
  const navigate = useNavigate();
  const [, setChangelog] = useState();
  const [anchorEl, setAnchorEl] = useState(null);
  const [nNodes, setNNodes] = useState(0);

  // ✅ NEW: dropdown licenze AGENT
  const [, setAgentLicenses] = useState([]);
  const [selectedAgentLicense, setSelectedAgentLicense] = useState("");
  const [, setLoadingAgentLicenses] = useState(false);

  const openDropDown = (event) => {
    setAnchorEl(event.currentTarget);
  };
  const closeDropDown = () => {
    setAnchorEl(null);
  };

  const handleLogout = () => {
    API.logout({})
      .then(() => {
        window.sessionStorage.clear();
        navigate("/");
      })
      .catch(() => {
        window.sessionStorage.clear();
        navigate("/");
      });
    closeDropDown();
  };

  const goToUserOptions = () => {
    window.sessionStorage.setItem("selectedTab", "Profile");
    navigate("/user/options");
    closeDropDown();
  };

  const goToTickets = () => {
    window.sessionStorage.setItem("selectedTab", "Ticket");
    navigate("/user/support/ticket");
    closeDropDown();
  };

  const goToNotify = () => {
    window.sessionStorage.setItem("selectedTab", "Notify");
    navigate("/user/notifications");
    closeDropDown();
  };

  const goToInventory = () => {
    navigate("/user/network-status/status");
  };

  // ✅ NEW: fetch licenze AGENT
  const fetchAgentLicenses = () => {
    setLoadingAgentLicenses(true);

    API.getCodAttivazioneAgent()
      .then((res) => {
        const data = Array.isArray(res?.data) ? res.data : [];

        // supporta: array di stringhe oppure array di oggetti { codiceAttivazione: "..." }
        const normalized = data
          .map((x) => (typeof x === "string" ? x : x?.codiceAttivazione))
          .filter(Boolean);

        setAgentLicenses(normalized);

        if (!selectedAgentLicense && normalized.length > 0) {
          setSelectedAgentLicense(normalized[0]);
        }

      })
      .catch((err) => {
        console.error('[fetchAgentLicenses] failed to fetch agent licenses:', err);
        setAgentLicenses([]);
      })
      .finally(() => {
        setLoadingAgentLicenses(false);
      });
  };

  useEffect(() => {
    if (sessionStorage.getItem("changelog")) {
      setChangelog(sessionStorage.getItem("changelog"));
    } else {
      API.get_user_options().then((response) => {
        setChangelog(response.data.changeLog);
        sessionStorage.setItem("changelog", response.data.changeLog);
      });
    }

    API.getHosts()
      .then((res) => {
        setNNodes(res.data.count);
        sessionStorage.setItem("numberNodes", res.data.count);
      })
      .catch((err) => {
        console.error('[Topbar] failed to fetch hosts:', err);
      });

    // ✅ carica licenze dropdown al mount
    fetchAgentLicenses();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return (
    <Box
      className="sticky top-0 flex justify-between z-10 h-14 p-2 bg-topbar-dark"
      display="flex"
      alignItems="center"
      justifyContent="space-between"
      p={1.7}
    >
      <Box display="flex" alignItems="center" sx={{ flex: 1 }}>
        {window.innerWidth > 1024 ? null : (
          <Box>
            <img
              src="/logoWhite.png"
              alt="LECS"
              style={{ width: "auto", height: "30px" }}
            />
          </Box>
        )}
        <Tour />
      </Box>

      <Box display="flex" alignItems="center" gap={2}>
        {/* <IconButton onClick={handleMultiView}>
          <SplitscreenIcon />
        </IconButton> */}
        <Typography fontWeight="bold" sx={{ fontSize: { md: "0.8vw", xs: "2.7vw" } }}>
          <SelectLecs />
        </Typography>
      </Box>

      {/* ICONS */}
      <Box display="flex" alignItems="center" sx={{ flex: 1, justifyContent: "flex-end" }}>
        <IconButton onClick={goToInventory} sx={{ borderRadius: 1, "&:hover": { backgroundColor: "#ffffff0d" } }}>
          <TotalNodes nNodes={nNodes} />
        </IconButton>

        {/* <IconButton
          onClick={goToChangeLog}
          className={changelog == "true" ? "blinking" : ""}
        >
          <FiberNewIcon />
        </IconButton> */}

        {window.innerWidth > 1024 ? <NotifyMenu /> : <></>}

        <IconButton onClick={goToUserOptions}>
          <SettingsOutlinedIcon />
        </IconButton>

        <IconButton onClick={openDropDown}>
          <PersonOutlinedIcon />
        </IconButton>

        <Menu
          id="simple-menu"
          anchorEl={anchorEl}
          open={Boolean(anchorEl)}
          onClose={closeDropDown}
        >
          <MenuItem onClick={goToTickets}>Tickets</MenuItem>

          {window.innerWidth < 1024 ? (
            <MenuItem onClick={goToNotify}>Notifications</MenuItem>
          ) : (
            <></>
          )}

          <MenuItem onClick={handleLogout}>Logout</MenuItem>
        </Menu>
      </Box>
    </Box>
  );
};

export default Topbar;
